import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const PlanContext = createContext(null);

const ORG_PORTAL_ROLES = new Set([
  "ORG_ADMIN", "SALES_MARKETING_MANAGER", "SALES_EXECUTIVE", "SALES_MANAGER",
  "PROCUREMENT_MANAGER", "INVENTORY_MANAGER", "FINANCE_MANAGER",
  "PRODUCTION_MANAGER", "LAB", "QC_QA",
  "WAREHOUSE_MANAGER", "WAREHOUSE_EXECUTIVE",
  "STORE_MANAGER", "STORE_EXECUTIVE",
  "PURCHASE_MANAGER", "PURCHASE_EXECUTIVE",
  "FINANCE_EXECUTIVE", "DISPATCH_MANAGER", "DISPATCH_EXECUTIVE",
  "SALES_COORDINATOR",
]);

export function PlanProvider({ children }) {
  const { user } = useAuth();
  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!user || !ORG_PORTAL_ROLES.has(user.role)) {
      setPlan(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/org/effective-plan");
      setPlan(data);
    } catch {
      setPlan(null);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <PlanContext.Provider value={{ plan, loading, refresh }}>
      {children}
    </PlanContext.Provider>
  );
}

export function usePlan() {
  return useContext(PlanContext) || { plan: null, loading: false, refresh: () => {} };
}
